import { useContext as o } from "react";
import { ToastManagerContext as r } from "./ToastManagerContext.mjs";
const a = () => {
  const t = o(r);
  if (!t.api)
    throw Error("cant use Toast outside of ToastContext!");
  return t.api.current;
};
export {
  a as useToast
};
//# sourceMappingURL=useToast.mjs.map
